// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"51980cad","160":"b3e07c31","208":"65bfdf6c","293":"3911cf34","453":"62d9e975","516":"da912ac3","519":"bf13bd2e","917":"b6425225","946":"8c23ed4f"}[chunkId] + ".chunk.js";
};